import { Instagram, Youtube } from "lucide-react";

const SOCIALS = [
  { name: "Instagram", handle: "@IAmManuelSantana", url: "https://instagram.com/IAmManuelSantana", Icon: Instagram },
  { name: "YouTube", handle: "@IAmManuelSantana", url: "https://youtube.com/@IAmManuelSantana", Icon: Youtube },
  {
    name: "TikTok",
    handle: "@IAmManuelSantana",
    url: "https://tiktok.com/@IAmManuelSantana",
    Icon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.16a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.59Z" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-[#FFFFFF] mt-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-5">
            <div className="font-display font-black tracking-tighter text-3xl leading-none">
              12<span className="text-[#D92D20]">/</span>LAWS
            </div>
            <p className="mt-6 max-w-md text-[#A3A3A3] leading-relaxed">
              Once you understand the laws that govern dating dynamics, you stop guessing — and start moving with awareness.
            </p>
            <div className="mt-8">
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#737373] mb-3">Follow Manuel</div>
              <div className="flex flex-wrap gap-3">
                {SOCIALS.map(({ name, url, Icon }) => (
                  <a
                    key={name}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 border border-white/15 px-4 py-2.5 text-xs uppercase tracking-[0.18em] hover:border-[#D92D20] hover:text-[#D92D20] transition-colors"
                    data-testid={`footer-social-${name.toLowerCase()}`}
                  >
                    <Icon className="w-4 h-4" />
                    {name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="col-span-1 md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#737373] mb-4">Book</div>
            <ul className="space-y-2 text-sm">
              <li><a href="/#laws" className="hover:text-[#D92D20]">The 12 Laws</a></li>
              <li><a href="/#reviews" className="hover:text-[#D92D20]">Reviews</a></li>
              <li><a href="/#details" className="hover:text-[#D92D20]">Details</a></li>
              <li><a href="/checkout" className="hover:text-[#D92D20]">Order Your Copy</a></li>
            </ul>
          </div>

          <div className="col-span-1 md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#737373] mb-4">Help</div>
            <ul className="space-y-2 text-sm">
              <li><a href="/track" className="hover:text-[#D92D20]" data-testid="footer-track">Track your order</a></li>
              <li><a href="/contact" className="hover:text-[#D92D20]" data-testid="footer-contact">Contact &amp; support</a></li>
              <li><a href="/refund-policy" className="hover:text-[#D92D20]" data-testid="footer-refund">Refund policy</a></li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#737373] mb-4">Legal</div>
            <ul className="space-y-2 text-sm">
              <li><a href="/terms" className="hover:text-[#D92D20]" data-testid="footer-terms">Terms of service</a></li>
              <li><a href="/privacy" className="hover:text-[#D92D20]" data-testid="footer-privacy">Privacy policy</a></li>
              <li className="text-[#A3A3A3] pt-2 text-xs font-mono-plex">@IAmManuelSantana</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-[#737373]">
          <div>© {new Date().getFullYear()} Penmier Publishing. All rights reserved.</div>
          <div>ISBN 979-8218677480 · 305 pages · Paperback</div>
        </div>
      </div>
    </footer>
  );
}

export { SOCIALS };
